<template>
  <div>
    <home-carousel />
    <div
      class="knews"
      :class="{ 'game-type': gameLobby }"
    >
      <div class="news-img">
        <img :src="$getThemeImagePath('bullhorn.svg')" alt="">
      </div>

      <div
        ref="marqueeContainer"
        class="news-body"
        @mouseenter="stopMarquee"
        @mouseleave="startMarquee"
      >
        <!-- 公告重複多份接續捲動，避免一輪結尾出現空白；複本不給輔助技術重複朗讀 -->
        <a
          v-for="(item, index) in marqueeLoopItems"
          :key="index"
          :style="marqueeStyle"
          :aria-hidden="index >= marqueeItems.length ? 'true' : null"
          @click="goNewsPage(index % marqueeItems.length + 1)"
        >
          <span class="subtitle">
            {{ item.title }}
          </span>
        </a>
      </div>
      <a class="news-more" @click="goNewsPage('')">{{ $t('Bao.news_more') }}<i class="fa-solid fa-chevron-right" /></a>
    </div>

    <search-game v-if="isMobile()" :all-game="allGame" />

    <div class="main-max-width">
      <div class="game-quick-link">
        <!-- 點擊 All -->
        <div
          v-if="!isFirstRender && currentGameCategory || activeFilter === 'favorites' &&
            catagoryList && catagoryList.length > 0"
          ref="gameCategoryContainer"
          class="slider provider-container list category-filter"
          role="group"
        >
          <div ref="categoryContainer">
            <div
              v-for="(item, key) in catagoryList"
              :key="key"
              :class="{ active: isGameCategoryActive(item) }"
            >
              <a
                href="#"
                role="button"
                :data-category-icon="getCategoryIcon(item)"
                :data-icon-source="item.isFavGame ? null : 'uploaded'"
                :class="{ 'original-image-icon': isOriginalImageIcon(item) }"
                @click.prevent="changeGameCategory(item)"
              >
                <img :src="item.image_banner" alt="">
                <span>{{ item.isFavGame ? $t('Bao.my_favorite') : item.name }}</span>
              </a>
            </div>
          </div>
        </div>

        <!-- 手機版搜尋改由 tab bar 放大鏡開啟，首頁不顯示頁內搜尋列 -->
        <div v-if="!isFirstRender || !isMobile()" class="lobby-search-bar" :class="{ 'game-type': !isFirstRender }">
          <ul>
            <!-- 點進標籤（含我的最愛）後才可選供應商（沿用原本 changeGameProvider） -->
            <li v-if="isGameCatalog" ref="providerFilter" class="provider-multiselect">
              <button
                type="button"
                class="provider-filter-toggle"
                :class="{ 'has-selection': !!currentGameProvider }"
                :aria-label="$t('Bao.provider')"
                :title="$t('Bao.provider')"
                :aria-expanded="String(showProviderFilter)"
                @click="showProviderFilter = !showProviderFilter"
              >
                <span class="provider-filter-icon" aria-hidden="true" />
              </button>
              <div v-show="showProviderFilter" class="provider-filter-panel">
                <div class="provider-filter-options" role="group" :aria-label="$t('Bao.provider')">
                  <label v-for="provider in providerFilterOptions" :key="provider.id">
                    <input
                      type="checkbox"
                      :checked="isProviderSelected(provider)"
                      @change="selectProvider(provider)"
                    >
                    <span>{{ provider.name }}</span>
                  </label>
                </div>
              </div>
            </li>
            <li v-if="!isMobile()" class="search-box" @click="showSearchGame()">
              <div class="slot-animation">
                <span>{{ $t('Bao.search_games_text1') }}</span>
                <span id="workHour" class="font-weight-bold work_hour font-xl">0</span>
                <span>{{ $t('Bao.search_games_text2') }}</span>
              </div>
              <i class="fa-solid fa-magnifying-glass iconSearch" />
            </li>
          </ul>
        </div>
        <template v-if="isFirstRender">
          <!-- 分類、活動、供應商同一個迴圈；活動依切版放在第二個分類之後，供應商放在我的最愛之後 -->
          <div
            v-for="item in homeSections"
            :key="item.isEvents ? 'new-events' : (item.isProviders ? 'original-providers' : item.id)"
            :class="getHomeSectionClass(item)"
            :role="item.isProviders ? 'region' : null"
            :aria-label="item.isProviders ? $t('Bao.provider') : null"
          >
            <template v-if="item.isProviders">
              <provider-carousel :providers="homeProviders" @select="changeGameProvider" />
            </template>
            <template v-else-if="item.isEvents">
              <div class="game-title">
                <!-- data-heading-icon：標題前顯示活動 icon（切版 game-interactions.js 依標題文字補上） -->
                <h2 data-heading-icon="bonus">
                  {{ $t('Bao.new_event') }}
                </h2>
              </div>
              <div class="new-events-div">
                <div
                  ref="carousel-event"
                  class="list"
                >
                  <div
                    v-for="banner in brandImage"
                    :key="banner.id"
                    class="new-swiper-slide"
                  >
                    <a @click.prevent="handleClick(banner.link,banner.open_type)">
                      <img :src="banner.image" alt="">
                    </a>
                  </div>
                </div>
                <!-- 活動輪播為環狀，箭頭點擊由 utils/promotionCarousel.js 處理 -->
                <div class="game-button-alpha">
                  <div class="game-next fa-solid fa-angle-left " />
                  <div class="game-prev fa-solid fa-angle-right " />
                </div>
              </div>
            </template>
            <template v-else>
              <div class="game-title">
                <a class="g-t-group" @click="showAllGame(item)">
                  {{ item.name }}
                  <div class="btn-to-allGames"><i class="fa-solid fa-angle-right" /></div>
                </a>
                <div class="game-bn">
                  <i class="button-icon btn-game-bn-all" @click="showAllGame(item)">{{ $t('Bao.show_all') }}</i>
                  <div class="button-icon angle-left">
                    <i
                      class="fa-solid fa-angle-left"
                      :class="{ disabled: !canScrollPrev(item.id) }"
                      @click=" prev(item.id)"
                    />
                  </div>
                  <div class="button-icon angle-right">
                    <i
                      class="fa-solid fa-angle-right"
                      :class="{ disabled: !canScrollNext(item.id) }"
                      @click=" next(item.id)"
                    />
                  </div>
                </div>
              </div>
              <div :key="componentKey" class="game-card-list">
                <div
                  :ref="item.id === -1 ? 'carousel-fav' : `carousel-${item.id}`"
                  class="game-card-list-div"
                >
                  <div
                    v-for="game in allCategoryGame[item.id]"
                    :key="game.id"
                    class="game-swiper-slide"
                  >
                    <game-card
                      :game="game"
                      :token="token"
                      :active="hover === game.id"
                      :provider-image="getProviderImage(game.game_provider_id)"
                      :data-category="item.id"
                      @hover="hover = $event"
                      @launch="handleLaunchGame"
                      @favorite="handleFavoriteGame"
                      @demo="openDemoGame"
                    />
                  </div>
                  <div class="game-button-alpha">
                    <div
                      class="game-next fa-solid fa-angle-left "
                      :class="{ disabled: !canScrollPrev(item.id) }"
                      @click=" prev(item.id)"
                    />
                    <div
                      class="game-prev fa-solid fa-angle-right "
                      :class="{ disabled: !canScrollNext(item.id) }"
                      @click=" next(item.id)"
                    />
                  </div>
                </div>
              </div>
            </template>
          </div>
        </template>
        <template v-else>
          <div class="game-main">
            <div class="game-section">
              <div class="game-title">
                <h2 v-if="activeFilter === 'favorites'">
                  {{ $t('Bao.my_favorite') }}
                </h2>
                <h2 v-else-if="currentGameCategory">
                  {{ currentGameCategory.name }}
                </h2>
                <h2 v-else-if="currentGameProvider">
                  {{ currentGameProvider.name }}
                </h2>
              </div>
              <div class="tabs-content">
                <div class="tab-inner">
                  <div class="game-card-list game-type">
                    <game-card
                      v-for="game in selectedCategoryGame"
                      :key="game.id"
                      :game="game"
                      :token="token"
                      :active="hover === game.id"
                      :provider-image="getProviderImage(game.game_provider_id)"
                      @hover="hover = $event"
                      @launch="handleLaunchGame"
                      @favorite="handleFavoriteGame"
                      @demo="openDemoGame"
                    />
                  </div>
                </div>
              </div>
            </div>
            <scroll-loader v-if="activeFilter === 'others'" :loader-method="getIndexGameList" :loader-disable="!enableAutoLoad" />
          </div>
        </template>
      </div>
    </div>
    <search-game v-if="!isMobile()" id="search_game_modal" :all-game="allGame" />
    <iframe-game v-if="gameUrlFromStore" :key="gameComponentKey" :all-game="allGame" :text="gameTextTitle" />
    <before-game-open-modal :is-active="gameModalOpen" />
    <currency-selection-modal :is-visible="showCurrencyModal" @close="showCurrencyModal = false" />
  </div>
</template>

<script>
import { getGames, getGamesV2, getFavoriteGameList, clearFavoriteGameListCache, getProviderGame, getGameNum } from '@/api/game'
import { addFavoriteGame, removeFavoriteGame, updateToken, info } from '@/api/user'
import { getMarqueeDetail } from '@/api/brand'
import { getEventDetail } from '@/api/event'
import { showToast, detectMob, initializeCountUp, updateCountUp, scrollToActive } from '@/utils/tool'
import { needPersonalData } from '@/utils/user'
import { initPromotionCarousel } from '@/utils/promotionCarousel'
import { gameEnd, launchGameWithProviderInfo } from '@/utils/games'
import gameCard from '@/components/gameCard'
import homeCarousel from '@/components/homeCarousel'
import providerCarousel from '@/components/providerCarousel'
import beforeGameOpenModal from '@/components/modal/beforeGameOpenModal'
import iframeGame from '@/components/modal/iframeGame'
import searchGame from '@/components/popup-box/searchGame'
import currencySelectionModal from '@/components/modal/currencySelectionModal'
import { mapMutations, mapGetters } from 'vuex'
import ScrollLoader from 'vue-scroll-loader/src/components/Scroll-Loader'
import themeMixin from '@/mixins/themeMixin'

export default {
  name: 'Index',
  components: {
    beforeGameOpenModal,
    gameCard,
    homeCarousel,
    providerCarousel,
    searchGame,
    iframeGame,
    ScrollLoader,
    currencySelectionModal
  },
  mixins: [themeMixin],
  data() {
    return {
      navigationHistory: [],
      allGame: [],
      selectedCategoryGame: [],
      allCategoryGame: [],
      favoriteAll: [],
      marqueeDetails: [],
      positionX: 100,
      speed: 0.8,
      marqueeCopies: 2,
      marqueeLoopWidth: 0,
      isRunning: false,
      animationFrameId: null,
      page: 1,
      page_size: 100, // 點擊 ALL 之後的遊戲數量
      game_size: 10, // 首頁遊戲數量
      isFirstRender: true,
      gameTextTitle: '',
      workHourVal: 0,
      hover: null,
      catagoryGame: [],
      catagoryList: [],
      allCategory: [],
      allProvider: [],
      allGameData: [],
      isFromBack: false,
      cardWidth: 193,
      actualGap: 16,
      componentKey: 0,
      isGameCategoryReady: false,
      enableAutoLoad: true,
      loading: false,
      showCurrencyModal: false,
      gameComponentKey: 0,
      providerImageMap: {},
      showProviderFilter: false,
      isHistoryNavigation: false
    }
  },
  metaInfo() {
    const isProduction = process.env.VUE_APP_ENV === 'production'

    if (!this.isTheme('theme_gold')) {
      return {}
    }

    const metaByType = {
      recommend: {
        title: '勝WINオンラインカジノおすすめゲーム！katsuwin',
        description: '勝WINでオンラインカジノおすすめゲームを楽しもう！',
        keywords: 'オンカジおすすめ,オンラインカジノおすすめ',
        gameTypeNumber: isProduction ? 29 : 84
      },
      new: {
        title: '勝WIN最新ゲーム｜オンカジスロット・パチンコ・パチスロ',
        description: '勝WIN最新ゲーム｜新作オンカジ・パチンコ・パチスロを楽しもう',
        keywords: 'スロットゲーム,スロット,ライブカジノ,パチンコ新台,パチンスロ新台',
        gameTypeNumber: isProduction ? 1 : 102
      },
      popular: {
        title: '勝WINオンラインカジノ人気ゲーム｜注目のオンカジ・パチンコ・パチスロ',
        description: '勝WIN人気ゲーム｜オンカジ・パチンコ・パチスロの人気タイトルを一目でチェック',
        keywords: 'オンカジ, 人気ゲーム, オンラインカジノ, 勝WIN, パチンコ, パチスロ, スロット',
        gameTypeNumber: isProduction ? 30 : 101
      },
      slot: {
        title: '勝WIN｜高RTPスロット＆ジャックポット付き人気ゲームを楽しもう',
        description: '勝WINで豊富なスロットゲームを楽しもう！高RTPやジャックポット付きのスロットが揃っており、ボーナスを活用して大当たりを狙えます。',
        keywords: 'スロットゲーム,スロット',
        gameTypeNumber: isProduction ? 13 : 100
      },
      live_casino: {
        title: '勝WIN｜ライブカジノでリアルな臨場感を体験しよう',
        description: '勝WINでライブカジノをプレイ！ブラックジャックやバカラ、ルーレットでリアルな臨場感を楽しもう。',
        keywords: 'ライブカジノ',
        gameTypeNumber: isProduction ? 12 : 87
      },
      pachislot: {
        title: '勝WIN｜人気パチスロゲームを楽しもう',
        description: '勝WINパチスロ｜人気ゲームで大当たりを狙おう',
        keywords: 'パチスロ',
        gameTypeNumber: isProduction ? 2 : 85
      },
      pachinko: {
        title: '勝WIN｜パチンコ人気ゲームを楽しもう',
        description: '勝WINパチンコ｜人気ゲームをまとめて楽しもう',
        keywords: 'パチンコ',
        gameTypeNumber: isProduction ? 14 : 97
      },
      crash: {
        title: 'クラッシュゲーム｜パチンコ人気ゲームを楽しもう',
        description: '勝WINパチンコ｜クラッシュゲームを楽しもう',
        keywords: 'クラッシュゲーム',
        gameTypeNumber: isProduction ? 6 : 86
      }
    }

    const gameCategoryId = this.currentGameCategory ? this.currentGameCategory.id : null
    const meta = Object.values(metaByType).find(m => m.gameTypeNumber === gameCategoryId)

    if (gameCategoryId && meta) {
      return {
        title: meta.title,
        meta: [
          { name: 'description', content: meta.description },
          { name: 'keywords', content: meta.keywords }
        ]
      }
    }

    return {
      title: 'アジアNo.1オンラインパチンコ・パチスロ『勝WIN』へようこそ  | 日本人プレイヤーのためのオンカジおすすめゲーム',
      meta: [
        { name: 'description', content: 'オンラインカジノ・オンカジおすすめなら勝WIN！日本人向けに特化した最新オンラインパチンコ・パチスロ・ライブカジノを楽しめるサイト。お得なボーナスやプロモーションも充実し、原則申請から1時間以内の出金に対応。' },
        { name: 'keywords', content: 'オンラインカジノ,オンカジ,勝WIN,katsuwin' }
      ]
    }
  },
  computed: {
    ...mapGetters(['token', 'user', 'brand', 'game', 'gameProvider', 'app', 'permissionInfo']),
    brandImage() {
      const brandImage = this.brand.brandImage.img_event
      return Array.isArray(brandImage)
        ? [...brandImage].sort((a, b) => a.sort - b.sort)
        : []
    },
    gameCategory() {
      const category = Array.isArray(this.$store.getters.gameCategory)
        ? this.$store.getters.gameCategory.slice()
        : []

      return [...category].sort((a, b) => a.sorting - b.sorting)
    },
    activeFilter() {
      return this.user.activeFilter
    },
    gameModalOpen() {
      return this.app.isModalActive
    },
    gameUrlFromStore() {
      return this.app.gameUrl
    },
    currentGameCategory() {
      return this.user.currentGameCategory
    },
    currentGameProvider() {
      return this.user.currentGameProvider
    },
    marqueeItems() {
      return this.marqueeDetails.filter(item => item.isShow)
    },
    marqueeLoopItems() {
      return Array.from({ length: this.marqueeCopies }).reduce(list => list.concat(this.marqueeItems), [])
    },
    marqueeStyle() {
      return {
        transform: `translateX(${this.positionX}px)`
      }
    },
    favoriteGamesId() {
      return this.user.favoriteGame || []
    },
    gameLobby() {
      return this.brand.showSearch || this.brand.showProvider ||
      this.currentGameCategory || this.currentGameProvider ||
      this.activeFilter === 'favorites'
    },
    walletSwitchRequest() {
      return this.$store.state.app.walletSwitchRequest
    },
    // 標籤頁對應切版 All Game（樣式以 body[data-game-catalog="all"] 限定）
    isGameCatalog() {
      return !this.isFirstRender && !!(this.currentGameCategory || this.currentGameProvider || this.activeFilter === 'favorites')
    },
    // 首頁區塊：分類中插入活動，依切版放在第二個分類之後；分類不足兩個時放在最後
    homeSections() {
      const sections = [...this.catagoryGame]
      if (sections.length) {
        sections.splice(Math.min(2, sections.length), 0, { isEvents: true })
      }
      // 供應商輪播依切版放在我的最愛之後；沒有我的最愛時放在最前面
      if (this.homeProviders.length) {
        sections.splice(sections.length && sections[0].id === -1 ? 1 : 0, 0, { isProviders: true })
      }
      return sections
    },
    providerFilterOptions() {
      const providers = Array.isArray(this.gameProvider) ? this.gameProvider : []
      return [...providers].sort((a, b) => a.sort - b.sort)
    },
    // 首頁供應商輪播：同一個 provider_group 只顯示一項（用 group 內第一筆的圖片、以 group 名稱為名），
    // providerIds 記下整個 group 的供應商，點擊時一次查詢；沒有 provider_group 的維持單獨一項
    homeProviders() {
      const groups = {}
      return this.providerFilterOptions.reduce((list, provider) => {
        const group = provider.provider_group
        if (!group) {
          list.push(provider)
        } else if (groups[group]) {
          groups[group].providerIds.push(provider.id)
        } else {
          groups[group] = { ...provider, name: group, providerIds: [provider.id] }
          list.push(groups[group])
        }
        return list
      }, [])
    }
  },
  watch: {
    // 瀏覽器上一頁／下一頁：畫面跟著網址切換（程式自行 replace 的網址不處理）
    '$route'(to) {
      if (!this.isHistoryNavigation) return
      this.isHistoryNavigation = false
      this.syncWithRoute(to)
    },
    isGameCatalog: {
      immediate: true,
      handler(value) {
        if (value) {
          document.body.dataset.gameCatalog = 'all'
        } else {
          delete document.body.dataset.gameCatalog
        }
      }
    },
    walletSwitchRequest: {
      handler(payload) {
        if (!payload?.game || Object.keys(payload.game).length === 0) return
        this.handleLaunchGame(payload.game)
      }
    },
    'gameCategory': {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.allCategory = newVal
          this.isGameCategoryReady = true
          this.checkAndInitialize()
        }
      }
    },
    'gameProvider': {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.buildProviderImageMap()
        }
      }
    },
    'activeFilter'(to) {
      if (to === 'others' && !this.currentGameCategory && !this.currentGameProvider) {
        this.initIndex()
      } else if (to === 'favorites') {
        this.isFirstRender = false
        // 點進我的最愛時一律重取，後台關閉的遊戲才會即時拿掉
        clearFavoriteGameListCache()
        this.updateFavoriteAll(this.favoriteGamesId)

        this.$nextTick(() => {
          this.gameScroll('gameCategoryContainer')
        })
      }
    },
    'currentGameCategory'(to) {
      this.showProviderFilter = false
      if (to !== null) {
        this.isFirstRender = false
        this.$store.commit('SET_ACTIVE_FILTER', 'others')
        this.getCatagoryList()
        this.ensureFavoriteCategory()
        this.queryGame()

        const category = this.allCategory.find(c => c.seo_path === to.seo_path)
        if (category && category.seo_path !== '') {
          // 如果目前網址沒有正確參數，就補上
          if (this.$route.params.seo_path !== category.seo_path) {
            // 以 push 新增歷史紀錄，上一頁才能回到前一個分類／首頁
            this.$router.push({ params: { seo_path: category.seo_path }})
          }
        }

        if (this.game.gameNum === 0) {
          this.getGameNum()
        } else {
          this.updateWorkHour(this.game.gameNum)
        }

        if (this.allProvider.length === 0) {
          this.getAllProvider()
        }

        this.$nextTick(() => {
          setTimeout(() => {
            this.clearQuery()
            this.gameScroll('gameCategoryContainer')
          }, 300)
        })
      } else if (to === null && !this.currentGameProvider) {
        if (this.activeFilter !== 'favorites') {
          this.initIndex()
        }
      }
    },
    'currentGameProvider'(to) {
      if (to !== null) {
        this.isFirstRender = false
        this.queryGame()

        if (this.game.gameNum === 0) {
          this.getGameNum()
        } else {
          this.updateWorkHour(this.game.gameNum)
        }

        this.$nextTick(() => {
          setTimeout(() => {
            this.clearQuery()
            // 捲到供應商篩選列，與選分類時捲到標籤列的位置一致
            this.gameScroll('providerFilter')
          }, 300)
        })
      } else {
        if (this.activeFilter !== 'favorites' && !this.currentGameCategory) {
          this.initIndex()
        }
      }
    },
    'gameUrlFromStore'(newVal, oldVal) {
      if (!newVal && oldVal) {
        gameEnd(this.app.inGameId)
        this.$store.commit('SET_PENDING_GAME_DATA', null)
        info().then(response => {
          const walletInfo = response.data.data.walletInfo
          this.$store.commit('SET_WALLET_INFO', walletInfo)

          const selectedWallet = walletInfo.find(wallet => wallet.wallet_type === this.app.selectedWallet.wallet_type)
          this.$store.commit('SET_SELECTED_WALLET', selectedWallet)
        }).catch(error => {
          console.error('Failed to refresh wallet data:', error)
        })
      }
    },
    'token'(newVal, oldVal) {
      this.initIndex()
      this.hover = null
    },
    '$store.state.app.pendingGameData'(newVal) {
      this.showCurrencyModal = !!newVal && !this.$store.state.app.gameUrl
    },
    '$store.state.app.isCurrencyChangeInProgress'(newVal, oldVal) {
      // When currency change starts, increment the key to force component re-mount
      if (newVal && !oldVal) {
        this.gameComponentKey++
        console.log('Forcing iframe-game component re-mount with key:', this.gameComponentKey)
      }
    }
  },
  beforeDestroy() {
    this.destroyPromotionCarousel()
    this.stopMarquee()
    document.removeEventListener('click', this.closeProviderFilterOnOutside, true)
    window.removeEventListener('popstate', this.onHistoryNavigation)
    delete document.body.dataset.gameCatalog
  },
  created() {
    if (this.user.isFromChampionship && !this.token) {
      this.$store.commit('SET_LOGIN_OPEN', true)
    }
    this.$store.commit('SET_CHAMPIONSHIP', false)
    if (this.user.isFromPromotion && !this.token) {
      this.$store.commit('SET_LOGIN_OPEN', true)
    }
    this.$store.commit('SET_PROMOTION', false)

    if (localStorage.getItem('fromSelfRestraint')) {
      this.$store.commit('SET_LOGIN_OPEN', true)
      localStorage.removeItem('fromSelfRestraint')
    }

    getMarqueeDetail().then(response => {
      this.marqueeDetails = response.data.data
      const userVipLevel = this.$store.state.user.memberInfo ? this.$store.state.user.memberInfo.vip_level_id : null
      const userMemberLevel = this.$store.state.user.memberInfo ? this.$store.state.user.memberInfo.vl : null
      this.marqueeDetails.forEach(item => {
        item.isShow = false
        if (!item.setting || !item.setting.allow_vip_levels || !item.setting.allow_member_levels) {
          item.isShow = true
          this.$store.commit('SET_MARQUEE_DETAIL', null)
          return
        }
        const allowedVipLevels = item.setting.allow_vip_levels
          .split(',')
          .map(s => s.trim())
          .filter(s => s)
          .map(Number)

        const allowedMemberLevels = item.setting.allow_member_levels
          .split(',')
          .map(s => s.trim())
          .filter(s => s)
          .map(Number)

        if (allowedVipLevels.includes(userVipLevel) &&
        allowedMemberLevels.includes(userMemberLevel)) {
          item.isShow = true
        }
        this.$store.commit('SET_MARQUEE_DETAIL', this.marqueeDetails)
      })

      if (this.user.newsId) {
        getEventDetail(this.user.newsId)
          .then(response => {
            const newsCount = response.data.data.reward.count
            const gameText = this.marqueeDetails.find(item => {
              return item.catalog === 'manual_first_deposit_v2'
            })

            if (newsCount > 0 && gameText) {
              this.gameTextTitle = gameText.title
            }
          })
      }

      this.$nextTick(() => {
        this.startMarquee()
      })
    })

    this.checkTokenExpiration()
    this.getAllGameForSearch()
  },
  mounted() {
    this.initializeCountUp()
    document.addEventListener('click', this.closeProviderFilterOnOutside, true)
    window.addEventListener('popstate', this.onHistoryNavigation)
    this.syncPromotionCarousel()
  },
  updated() {
    // 活動區只在首頁分類總覽時渲染，切換分類或活動資料更新後重新掛載輪播
    this.syncPromotionCarousel()
  },
  methods: {
    syncPromotionCarousel() {
      const ref = this.$refs['carousel-event']
      const strip = Array.isArray(ref) ? ref[0] : ref
      const signature = this.brandImage.map(banner => banner.id).join()
      if (strip === this.promoStrip && signature === this.promoSignature) return
      this.destroyPromotionCarousel()
      if (!strip) return
      this.promoStrip = strip
      this.promoSignature = signature
      this.stopPromotionCarousel = initPromotionCarousel(strip.parentElement)
    },
    destroyPromotionCarousel() {
      if (this.stopPromotionCarousel) this.stopPromotionCarousel()
      this.stopPromotionCarousel = null
      this.promoStrip = null
      this.promoSignature = null
    },
    onHistoryNavigation() {
      // vue-router 多半已先處理 popstate 並更新路由：直接依網址同步
      const { route } = this.$router.resolve(window.location.pathname + window.location.search)
      if (route.fullPath === this.$route.fullPath) {
        this.syncWithRoute(this.$route)
        return
      }
      // 路由尚未更新（例如還在載入 CSS）：交給 $route watcher 處理
      this.isHistoryNavigation = true
      clearTimeout(this.historyNavigationTimer)
      this.historyNavigationTimer = setTimeout(() => {
        this.isHistoryNavigation = false
      }, 1000)
    },
    syncWithRoute(route) {
      const seoPath = route.params.seo_path
      if (seoPath) {
        const category = this.allCategory.find(c => c.seo_path === seoPath)
        if (!category) return
        const providerSelected = !!this.currentGameProvider
        this.$store.commit('SET_CURRENT_GAME_PROVIDER', null)
        this.$store.commit('SET_ACTIVE_FILTER', 'others')
        if (!this.currentGameCategory || this.currentGameCategory.id !== category.id) {
          category.attribute = 'category'
          this.$store.commit('SET_CURRENT_GAME_CATEGORY', category)
        } else if (providerSelected) {
          // 同一分類但原本在供應商頁：重新載入分類遊戲
          this.queryGame()
        }
      } else if (Object.keys(route.query).length === 0 &&
        (this.currentGameCategory || this.currentGameProvider || this.activeFilter === 'favorites')) {
        this.$store.commit('SET_CURRENT_GAME_PROVIDER', null)
        this.$store.commit('SET_CURRENT_GAME_CATEGORY', null)
        // 清除後由 currentGameCategory／currentGameProvider／activeFilter 的 watcher 回到首頁
        this.$store.commit('SET_ACTIVE_FILTER', 'others')
      }
    },
    checkAndInitialize() {
      if (this.isGameCategoryReady && this.allCategory && this.allCategory.length > 0) {
        this.isInit()
      }
    },
    isInit() {
      // 從別的頁面回到首頁
      if (this.currentGameCategory) {
        if (localStorage.getItem('onlyOneGame')) {
          this.$store.commit('SET_CURRENT_GAME_CATEGORY', null)
          localStorage.removeItem('onlyOneGame')

          if (this.$route.params.seo_path) {
            this.$router.replace('/')
          }
        } else {
          this.isFirstRender = false
          this.$store.commit('SET_ACTIVE_FILTER', 'others')
          this.getCatagoryList()
          this.ensureFavoriteCategory()
          this.queryGame()
          this.getGameNum()
          this.getAllProvider()

          this.$nextTick(() => {
            setTimeout(() => {
              this.gameScroll('gameCategoryContainer')
            }, 300)
          })
        }
      } else if (this.currentGameProvider) {
        if (localStorage.getItem('onlyOneGame')) {
          this.$store.commit('SET_CURRENT_GAME_PROVIDER', null)
          localStorage.removeItem('onlyOneGame')
        } else {
          this.isFirstRender = false
          this.queryGame()
          this.getGameNum()
          this.getAllProvider()
        }

        this.$store.commit('SET_ACTIVE_FILTER', 'others')
      } else if (this.activeFilter === 'favorites') {
        this.isFirstRender = false

        this.getCatagoryList()
        this.updateFavoriteAll(this.favoriteGamesId)

        this.$nextTick(() => {
          this.gameScroll('gameCategoryContainer')
        })
      } else {
        this.initIndex()
      }
    },
    getAllProvider() {
      getProviderGame().then((response) => {
        this.allProvider = response.data.data
        this.allProvider.sort((a, b) => a.sort - b.sort)
        this.$store.commit('SET_GAME_PROVIDER', this.allProvider)
      })
    },
    handleQuery(queryKey, storeKey, source) {
      const queryValue = Number(this.$route.query[queryKey])
      const item = source.find(item => item.id === queryValue || item.game_type === queryValue)

      if (item) {
        this.$store.commit(storeKey, item)
      } else {
        this.clearQuery()
        this.initIndex()
      }
    },
    setQueryObj(query) {
      if (query.category) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.handleQuery('category', 'SET_CURRENT_GAME_CATEGORY', this.gameCategory)
          }, 1000)
        })
      } else if (query.provider_id) {
        if (!this.gameProvider) {
          this.getAllProvider()
          this.$nextTick(() => {
            setTimeout(() => {
              this.handleQuery('provider_id', 'SET_CURRENT_GAME_PROVIDER', this.gameProvider)
            }, 1000)
          })
        } else {
          this.handleQuery('provider_id', 'SET_CURRENT_GAME_PROVIDER', this.gameProvider)
        }
      } else if (query.share_code) {
        this.$store.commit('SET_REGISTER_OPEN', true)
        this.isFirstRender = true
        this.getIndexGameList()
      } else {
        this.clearQuery()
        this.initIndex()
      }
    },
    setCategoryObj(seo_path) {
      const category = this.allCategory.find(c => c.seo_path === seo_path)
      if (category) {
        this.$store.commit('SET_CURRENT_GAME_CATEGORY', category)
      } else {
        this.$router.replace('/')
        this.initIndex()
      }
    },
    initIndex() {
      const query = this.$route.query
      const hasParams = Object.keys(query).length > 0
      if (hasParams) {
        this.isFirstRender = false
        this.setQueryObj(query)
        return
      } else if (localStorage.getItem('fromLandingPageRegister') || localStorage.getItem('fromShareRegister')) {
        // 從落地頁或推廣鏈結(邀請碼)進站的訪客,到首頁後自動開啟註冊彈窗
        if (!this.token) {
          this.$store.commit('SET_REGISTER_OPEN', true)
        }

        localStorage.removeItem('fromLandingPageRegister')
        localStorage.removeItem('fromShareRegister')
        this.isFirstRender = true
        this.getIndexGameList()
        return
      }

      const seo_path = this.$route.params.seo_path
      if (seo_path) {
        this.isFirstRender = false
        this.setCategoryObj(seo_path)
        return
      }

      this.isFirstRender = true
      this.navigationHistory = []
      this.isFromBack = false

      this.$store.commit('SET_SHOW_RESEARCH', false)
      this.$store.commit('SET_SHOW_PROVIDER', false)

      this.getIndexGameList()

      this.$store.commit('SET_ACTIVE_FILTER', 'others')
      this.$store.commit('SET_CURRENT_GAME_CATEGORY', null)
      this.$store.commit('SET_CURRENT_GAME_PROVIDER', null)

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })

      this.resetScrollToStart('-1')
      this.allCategory.forEach(category => {
        this.resetScrollToStart(category.id)
      })

      this.componentKey += 1
    },
    handleBack() {
      if (this.navigationHistory.length > 0) {
        this.navigationHistory.pop()
        this.isFromBack = true

        const lastHistory = this.navigationHistory[this.navigationHistory.length - 1]
        if (!lastHistory) {
          this.initIndex()
        } else if (lastHistory.attribute === 'category') {
          this.$store.commit('SET_CURRENT_GAME_CATEGORY', lastHistory)
          this.$store.commit('SET_CURRENT_GAME_PROVIDER', null)
        } else if (lastHistory.attribute === 'provider') {
          this.$store.commit('SET_CURRENT_GAME_PROVIDER', lastHistory)
          this.$store.commit('SET_CURRENT_GAME_CATEGORY', null)
        } else {
          this.$store.commit('SET_ACTIVE_FILTER', 'favorites')
          this.$store.commit('SET_CURRENT_GAME_CATEGORY', null)
          this.$store.commit('SET_CURRENT_GAME_PROVIDER', null)
        }
      } else {
        if (this.activeFilter !== 'favorites') {
          this.initIndex()
        }
      }
    },
    queryGame() {
      this.allGameData = []
      this.selectedCategoryGame = []
      this.page = 1
      this.enableAutoLoad = true
      this.hover = null
      this.getIndexGameList()
    },
    async getIndexGameList() {
      this.$meta().refresh()
      this.$store.commit('SET_GAME_READY', false)

      if (!this.isFirstRender) {
        if (this.loading) return
        this.loading = true

        if (!this.currentGameCategory && !this.currentGameProvider) {
          this.loading = false

          setTimeout(() => {
            if (this.currentGameCategory || this.currentGameProvider) {
              this.getIndexGameList()
            }
          }, 100)
          return
        }

        let id = ''
        let queryObj = {}

        if (this.currentGameCategory) {
          id = this.currentGameCategory.id
          queryObj =
          {
            category: id,
            page: this.page,
            page_size: this.page_size
          }

          if (this.isFromBack) {
            this.isFromBack = false
          } else {
            this.navigationHistory.push(this.currentGameCategory)
          }
        } else if (this.currentGameProvider) {
          const { providerIds } = this.currentGameProvider
          id = this.currentGameProvider.id
          queryObj =
          {
            // 首頁輪播選的 group：同 group 的供應商 id 以 JSON 陣列一次查詢
            provider_id: providerIds ? JSON.stringify(providerIds) : id,
            page: this.page,
            page_size: this.page_size
          }

          if (this.isFromBack) {
            this.isFromBack = false
          } else {
            this.navigationHistory.push(this.currentGameProvider)
          }
        }

        // 供應商（含 group）直接從已載入的全量遊戲篩選，全量還沒載入完才打 API
        let gamesData = this.currentGameProvider && this.page === 1
          ? this.getProviderGamesFromAllGame(this.currentGameProvider)
          : null
        try {
          if (!gamesData) gamesData = await this.fetchGamesFromAPI(queryObj)
        } catch (error) {
          // 請求失敗時解除 loading，避免之後的切換/篩選都被擋住
          console.error('Failed to load games:', error)
          this.loading = false
          this.enableAutoLoad = false
          this.$store.commit('SET_GAME_READY', true)
          return
        }
        if (gamesData.list.length === 0) {
          this.loading = false
          this.enableAutoLoad = false
          this.$store.commit('SET_GAME_READY', true)
          return
        }

        this.allGameData = [...this.allGameData, ...gamesData.list]
        const processedGames = this.sortCategoryGames(gamesData.list)
        this.selectedCategoryGame = [...this.selectedCategoryGame, ...processedGames]

        if (this.allGameData.length === 1 && this.token) {
          localStorage.setItem('onlyOneGame', true)

          this.handleLaunchGame(processedGames[0])
          this.enableAutoLoad = false
        } else if (this.allGameData.length >= gamesData.page_info.total_count) {
          this.enableAutoLoad = false
        } else {
          this.page += 1
          this.enableAutoLoad = true
        }

        this.loading = false
        this.$store.commit('SET_GAME_READY', true)
      } else {
        this.getAllProvider()

        try {
          this.$store.commit('SET_LOADING_COUNT_PLUS', true)

          const categories = this.allCategory
          if (!categories || !Array.isArray(categories) || categories.length === 0) {
            console.error('無有效的遊戲分類資料')
            return
          }

          this.getCatagoryGame()

          const results = await this.fetchAllCategoryGames(categories)

          // 將結果整理成物件形式
          const groupedGames = {}
          results.forEach(result => {
            groupedGames[result.categoryId] = result.games
          })

          if (this.favoriteGamesId.length > 0) {
            await this.updateFavoriteAll(this.favoriteGamesId)

            const groupedFavoriteGames = {
              '-1': this.favoriteAll
            }

            this.allCategoryGame = {
              ...this.sortAllCategoryGames(groupedGames),
              ...groupedFavoriteGames
            }

            this.getCatagoryList()
          } else {
            this.allCategoryGame = this.sortAllCategoryGames(groupedGames)
          }

          this.$store.commit('SET_GAME_READY', true)

          this.getGameNum()
        } catch (error) {
          console.error('獲取遊戲資料錯誤:', error)
        } finally {
          this.$store.commit('SET_LOADING_COUNT_ZERO', true)
        }
      }
    },
    // 處理滾動加載觸發
    onScrollLoaderTriggered() {
      if (this.enableAutoLoad && !this.loading) {
        this.loadMoreGames()
      }
    },
    sortCategoryGames(gamesData) {
      return gamesData
        .filter(game => this.isActiveGame(game))
        .sort(this.sortGames)
        .map(game => {
          return {
            ...game,
            isFavorite: this.isGameFavorite(game.id)
          }
        })
    },
    sortAllCategoryGames(gamesObj) {
      const result = {}
      Object.keys(gamesObj).forEach(categoryId => {
        result[categoryId] = gamesObj[categoryId]
          .filter(game => this.isActiveGame(game))
          .sort(this.sortGames)
          .map(game => {
            return {
              ...game,
              isFavorite: this.isGameFavorite(game.id)
            }
          })
      })
      return result
    },
    sortGames(a, b) {
      const aHasNew = a.brand_game_category_id.includes('NEW')
      const bHasNew = b.brand_game_category_id.includes('NEW')
      const aHasHot = a.brand_game_category_id.includes('HOT')
      const bHasHot = b.brand_game_category_id.includes('HOT')

      // Prioritize 'NEW' over 'HOT'
      if (aHasNew && !bHasNew) {
        return -1 // 'NEW' comes first
      }
      if (!aHasNew && bHasNew) {
        return 1 // 'NEW' comes first
      }

      // Prioritize 'HOT' if neither has 'NEW'
      if (aHasHot && !bHasHot) {
        return -1 // 'HOT' comes first
      }
      if (!aHasHot && bHasHot) {
        return 1 // 'HOT' comes first
      }

      // Fallback to sorting by recommend_sort
      return a.recommend_sort - b.recommend_sort
    },
    showAllGame(game) {
      if (!this.game.isGameReady) return

      this.isFirstRender = false
      this.allGameData = []
      this.selectedCategoryGame = []

      if (game.id === -1) {
        this.$store.commit('SET_ACTIVE_FILTER', 'favorites')
      } else {
        game.attribute = 'category'
        this.$store.commit('SET_CURRENT_GAME_CATEGORY', game)
      }

      this.$nextTick(() => {
        this.gameScroll('gameCategoryContainer')
      })
    },
    // 我的最愛分類鈕的主題圖是否以彩色原圖顯示（不套用單色濾鏡）；後台分類圖一律由 data-icon-source="uploaded" 顯示原圖
    isOriginalImageIcon(item) {
      return item.isFavGame && this.hasFeature('showFavoriteImage')
    },
    // 我的最愛分類鈕的 icon：預設用線框愛心，主題設定 showFavoriteImage 時改用主題圖
    getCategoryIcon(item) {
      if (!item.isFavGame) return null
      return this.hasFeature('showFavoriteImage') ? null : 'favorites'
    },
    getCatagoryList() {
      if (this.token && (this.favoriteAll.length > 0)) {
        // 主題設定 showFavoriteImage（TI 金色愛心）時改用主題的 favorite.png，其餘沿用分類橫幅圖 icon_tab_favorite.png
        const customItem = {
          image_banner: this.$getThemeImagePath(this.hasFeature('showFavoriteImage') ? 'favorite.png' : 'icon_tab_favorite.png'),
          isFavGame: true
        }
        this.catagoryList = [customItem, ...this.gameCategory]
      } else {
        this.catagoryList = this.gameCategory
      }
    },
    getCatagoryGame() {
      if (this.token && this.favoriteAll.length > 0) {
        const updatedCategory = [...this.gameCategory]
        const customItem = {
          id: -1,
          name: this.$t('Bao.my_favorite')
        }
        updatedCategory.unshift(customItem)
        this.catagoryGame = updatedCategory
      } else {
        this.catagoryGame = this.gameCategory
      }
    },
    prev(categoryId) {
      if (categoryId === 'category') {
        const container = this.$refs.categoryContainer
        if (!container) return

        const firstChild = container.firstElementChild
        const itemWidth = firstChild ? firstChild.offsetWidth : 0
        const gap = 16 // Same as CSS gap
        const scrollAmount = itemWidth + gap

        container.scrollBy({
          left: -scrollAmount,
          behavior: 'smooth'
        })
      } else {
        let container = ''
        let cardWidth = ''

        if (categoryId !== 'event') {
          const key = categoryId < 0 ? 'fav' : categoryId.toString()
          container = this.$refs[`carousel-${key}`]
          cardWidth = this.cardWidth
        } else {
          container = this.$refs['carousel-event']
          cardWidth = 290
        }

        const element = Array.isArray(container) ? container[0] : container
        if (!element) return false
        const scrollStep = cardWidth + this.actualGap

        element.scrollTo({
          left: element.scrollLeft - scrollStep,
          behavior: 'smooth'
        })
      }
    },
    next(categoryId) {
      if (categoryId === 'category') {
        const container = this.$refs.categoryContainer
        if (!container) return

        const firstChild = container.firstElementChild
        const itemWidth = firstChild ? firstChild.offsetWidth : 0
        const gap = 16 // Same as CSS gap
        const scrollAmount = itemWidth + gap

        container.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        })
      } else {
        let container = ''
        let cardWidth = ''

        if (categoryId !== 'event') {
          const key = categoryId < 0 ? 'fav' : categoryId.toString()
          container = this.$refs[`carousel-${key}`]
          cardWidth = this.cardWidth
        } else {
          container = this.$refs['carousel-event']
          cardWidth = 290
        }

        const element = Array.isArray(container) ? container[0] : container
        if (!element) return false
        const scrollStep = cardWidth + this.actualGap

        element.scrollTo({
          left: element.scrollLeft + scrollStep,
          behavior: 'smooth'
        })
      }
    },
    canScrollPrev(categoryId) {
      if (categoryId === 'category') {
        const container = this.$refs.categoryContainer
        return container ? container.scrollLeft > 0 : false
      }
      let container = ''
      if (categoryId !== 'event') {
        const key = categoryId < 0 ? 'fav' : categoryId.toString()
        container = this.$refs[`carousel-${key}`]
      } else {
        container = this.$refs['carousel-event']
      }

      const element = Array.isArray(container) ? container[0] : container
      if (!element) return false
      return element.scrollLeft > 0
    },
    canScrollNext(categoryId) {
      if (categoryId === 'category') {
        const container = this.$refs.categoryContainer
        return container ? container.scrollLeft < (container.scrollWidth - container.clientWidth) : false
      }
      let container = ''
      if (categoryId !== 'event') {
        const key = categoryId < 0 ? 'fav' : categoryId.toString()
        container = this.$refs[`carousel-${key}`]
      } else {
        container = this.$refs['carousel-event']
      }

      const element = Array.isArray(container) ? container[0] : container
      if (!element) return false
      return element.scrollLeft < (element.scrollWidth - element.clientWidth)
    },
    // 滾動到第一筆
    resetScrollToStart(categoryId) {
      const key = categoryId < 0 ? 'fav' : categoryId.toString()
      const container = this.$refs[`carousel-${key}`]
      const element = Array.isArray(container) ? container[0] : container
      if (!element) return

      element.scrollTo({
        left: 0,
        behavior: 'smooth'
      })
    },
    isGameFavorite(gameId) {
      return this.favoriteGamesId.some(fav => fav.game_id === gameId)
    },
    checkGameLength(currentGames) {
      if (!Array.isArray(currentGames)) return false

      const validGames = currentGames.filter(game => this.isActiveGame(game))

      // 直接返回是否有足够的有效游戏
      return validGames.length >= this.game_size
    },
    async fetchAllCategoryGames(categories) {
      const categoryIds = categories.map(category => category.id)
      const responses = await getGamesV2({
        category: JSON.stringify(categoryIds),
        page: 1,
        page_size: this.game_size
      })

      if (!responses || !responses.data || !responses.data.data) {
        console.error('No valid response from API')
        return []
      }

      // 初始处理每个类别的数据
      const initialResults = categoryIds.map(categoryId => {
        const response = responses.data.data[categoryId]
        const gamesList = response && response.list ? [...response.list] : []

        // 计算有效游戏数量
        const validGames = gamesList.filter(game => this.isActiveGame(game))

        return {
          categoryId,
          games: gamesList,
          // 检查有效游戏的数量是否足够
          hasEnoughGames: validGames.length >= this.game_size,
          pageInfo: response ? response.page_info : null,
          currentPage: 2 // 准备从第二页开始
        }
      })

      // 找出需要更多游戏的类别
      const categoriesNeedingMoreGames = initialResults.filter(
        result => !result.hasEnoughGames &&
             result.pageInfo &&
             result.currentPage <= result.pageInfo.page_count
      )

      // 当前页码，从第2页开始
      let currentPageNumber = 2

      // 如果有类别需要更多游戏
      while (categoriesNeedingMoreGames.length > 0) {
        // 收集当前页码需要请求的类别ID
        const idsToFetch = categoriesNeedingMoreGames
          .filter(category => category.currentPage === currentPageNumber)
          .map(category => category.categoryId)

        // 如果没有需要当前页码的类别，增加页码并继续
        if (idsToFetch.length === 0) {
          currentPageNumber++
          continue
        }

        // 请求当前页码的数据
        const additionalData = await getGamesV2({
          category: JSON.stringify(idsToFetch),
          page: currentPageNumber,
          page_size: this.game_size
        })

        if (!additionalData || !additionalData.data || !additionalData.data.data) {
          console.error(`页码 ${currentPageNumber} 的API返回无效数据`)
          break
        }

        // 处理每个类别的额外数据
        for (let i = categoriesNeedingMoreGames.length - 1; i >= 0; i--) {
          const category = categoriesNeedingMoreGames[i]

          // 只处理当前页码匹配的类别
          if (category.currentPage !== currentPageNumber) continue

          const newData = additionalData.data.data[category.categoryId]

          if (newData && newData.list && newData.list.length > 0) {
            // 计算新数据中的有效游戏数量
            newData.list.filter(game => this.isActiveGame(game))

            // 将新游戏添加到原始结果中
            const resultIndex = initialResults.findIndex(r => r.categoryId === category.categoryId)
            if (resultIndex !== -1) {
              // 添加新数据
              initialResults[resultIndex].games = [
                ...initialResults[resultIndex].games,
                ...newData.list
              ]

              // 检查是否有足够的有效游戏
              const validGames = initialResults[resultIndex].games.filter(g => this.isActiveGame(g))

              if (validGames.length >= this.game_size) {
                // 移除已经有足够游戏的类别
                categoriesNeedingMoreGames.splice(i, 1)
              } else {
                // 更新页数，准备请求下一页
                category.currentPage++
                if (category.currentPage > category.pageInfo.page_count) {
                  categoriesNeedingMoreGames.splice(i, 1)
                }
              }
            }
          } else {
            // 如果没有数据返回，从列表中移除
            categoriesNeedingMoreGames.splice(i, 1)
          }
        }

        // 增加页码，准备下一次请求
        currentPageNumber++

        // 如果所有类别都已处理完毕或页码超过最大值，退出循环
        if (categoriesNeedingMoreGames.length === 0 || currentPageNumber > 100) {
          break
        }
      }

      // 最终处理每个类别的游戏数据
      return initialResults.map(result => {
        // 过滤出有效游戏
        const validGames = result.games.filter(game => this.isActiveGame(game))

        const processedGames = validGames
          .slice(0, this.game_size)
          .sort(this.sortGames)
          .map(game => ({
            ...game,
            isFavorite: this.isGameFavorite(game.id)
          }))

        return { categoryId: result.categoryId, games: processedGames }
      })
    },
    buildProviderImageMap() {
      const providers = this.gameProvider
      if (!providers || providers.length === 0) return

      const map = {}
      for (const provider of providers) {
        if (!map[provider.id]) {
          map[provider.id] = provider.sidebar_image_app
        }
      }
      this.providerImageMap = map
    },
    getProviderImage(providerId) {
      return this.providerImageMap[providerId] || ''
    },
    startMarquee() {
      if (this.isRunning) return
      this.isRunning = true

      const moveText = () => {
        if (!this.isRunning) return
        this.measureMarqueeLoop()
        this.positionX -= this.speed

        // 第一份完全移出後往回接一份的寬度，畫面與下一份銜接，不會出現空白
        if (this.marqueeLoopWidth && this.positionX <= -this.marqueeLoopWidth) {
          this.positionX += this.marqueeLoopWidth
        }

        this.animationFrameId = requestAnimationFrame(moveText)
      }

      moveText()
    },
    // 一份公告的寬度＝第二份第一則與第一份第一則的距離（含間距）；份數補到足以填滿容器
    measureMarqueeLoop() {
      const container = this.$refs.marqueeContainer
      const count = this.marqueeItems.length
      if (!container || !count || container.children.length < count * 2) return
      const width = container.children[count].offsetLeft - container.children[0].offsetLeft
      if (width <= 0) return
      this.marqueeLoopWidth = width
      const copies = Math.max(2, Math.ceil(container.clientWidth / width) + 1)
      if (copies !== this.marqueeCopies) this.marqueeCopies = copies
    },
    stopMarquee() {
      this.isRunning = false
      cancelAnimationFrame(this.animationFrameId)
    },
    goNewsPage(key) {
      if (key) {
        this.$store.commit('SET_CHOOSE_NEWS', key)
      }
      this.$router.push({ path: '/user/news' })
    },
    gameScroll(refName) {
      this.$nextTick(() => {
        scrollToActive(this.$refs[refName])

        const activeElements = this.$refs[refName]

        if (!activeElements || activeElements === undefined) {
          let top = 450
          if (this.isMobile()) {
            top = 0
          }

          window.scrollTo({ top, behavior: 'smooth' })
        } else {
          const activeFilter = Array.isArray(activeElements)
            ? activeElements.find(el => el.classList.contains('active'))
            : activeElements

          if (activeFilter) {
            let offset = 30
            if (this.isMobile()) {
              offset = 120
            }
            const top = activeFilter.getBoundingClientRect().top + window.scrollY - offset
            window.scrollTo({ top, behavior: 'smooth' })
          }
        }
      })
    },
    updateWorkHour(newValue) {
      this.workHourVal = newValue

      this.$nextTick(() => {
        updateCountUp('workHour', newValue)
      })
    },
    isMobile() {
      return detectMob()
    },
    handleClick(banner_url, open_type) {
      if (banner_url === '/personal/data/modal') {
        // 需補個資才導去個資頁，否則留在首頁，避免先進頁再被彈回
        if (needPersonalData(this.$store.getters.memberInfo, this.permissionInfo)) {
          this.$router.push(banner_url)
        }
        return
      }

      let id = null
      const eventIdMatch = banner_url.match(/eventId=(\d+)/)

      if (eventIdMatch) {
        id = eventIdMatch[1]
      }

      switch (open_type) {
        case 'self':
          if (id) {
            // 有 eventId,導向 event 頁面
            this.$router.push({ path: '/event', query: { eventId: id }})
          } else {
            // 沒有 eventId,直接導向 link
            window.location.href = banner_url
          }
          break

        case 'iframe':
          this.$store.commit('SET_GAME_URL', banner_url)
          break

        case 'new':
          window.open(banner_url, '_blank')
          break

        default:
          if (id) {
            this.$router.push({ path: '/event', query: { eventId: id }})
          } else {
            window.location.href = banner_url
          }
      }
    },
    async handleFavoriteGame(game) {
      const gameInfo = {
        type: 'game',
        data: JSON.stringify([{
          brand_id: this.user.goldInfo.brand_id,
          game_id: game.id
        }])
      }
      try {
        const response = game.isFavorite
          ? await removeFavoriteGame(gameInfo)
          : await addFavoriteGame(gameInfo)

        this.$store.commit('SET_FAVORITE_GAME', response.data.data.game)
        this.showToast(game, !game.isFavorite)

        // 切換最愛時不跳全頁 loading，避免像整頁重新整理
        await this.updateFavoriteAll(this.favoriteGamesId, { noLoading: true })
        if (this.currentGameCategory || this.currentGameProvider) {
          this.selectedCategoryGame = this.sortCategoryGames(this.selectedCategoryGame)
        } else {
          const groupedFavoriteGames = {
            '-1': this.favoriteAll
          }
          this.allCategoryGame = {
            ...this.sortAllCategoryGames(this.allCategoryGame),
            ...groupedFavoriteGames
          }
          this.getCatagoryGame()
          this.resetScrollToStart('-1')
        }
      } catch (error) {
        console.error(error)
      }
    },
    showToast(game, isFavorite) {
      const message = isFavorite ? `${game.name} ${this.$t('Bao.favorite')}` : `${game.name} ${this.$t('Bao.favorite_remove')}`
      showToast(message)
      setTimeout(() => {
        this.$store.commit('SET_TOAST_MESSAGE', null)
      }, 3000)
    },
    async updateFavoriteAll(favorArr, customConfig) {
      await this.loadFavoriteAll(favorArr, customConfig)

      if (this.isFirstRender) {
        return
      }

      if (this.isFromBack) {
        this.isFromBack = false
      } else {
        this.navigationHistory.push({ attribute: 'favorites' })
      }
    },
    // 只取最愛遊戲並更新分類列，不記錄瀏覽紀錄
    async loadFavoriteAll(favorArr, customConfig) {
      let gamesData = []
      const favoriteGameIds = new Set(favorArr.map(favGame => favGame.game_id))
      await getFavoriteGameList(Array.from(favoriteGameIds), customConfig)
        .then((response) => {
          gamesData = response.data.data
        })
        .catch((err) => {
          console.log(err)
        })
      const processedGames = gamesData
        .filter(game => this.isActiveGame(game))
        .sort(this.sortGames)
        .map(game => {
          return {
            ...game,
            isFavorite: favoriteGameIds.has(game.id)
          }
        })

      this.favoriteAll = processedGames
      this.favoriteAll.attribute = 'favorites'

      if (this.activeFilter === 'favorites') {
        this.selectedCategoryGame = this.favoriteAll
      }

      this.getCatagoryList()
      this.getCatagoryGame()
    },
    // 直接進分類頁（重新整理、從其他頁面點分類）時首頁尚未取過最愛遊戲，補取後分類列才會出現我的最愛
    ensureFavoriteCategory() {
      if (this.token && this.favoriteGamesId.length > 0 && this.favoriteAll.length === 0) {
        this.loadFavoriteAll(this.favoriteGamesId, { noLoading: true })
      }
    },
    initializeCountUp,
    getGameNum() {
      getGameNum().then((response) => {
        this.$store.commit('SET_GAME_NUM', response.data.num)
        this.updateWorkHour(response.data.num)
      })
        .catch((err) => {
          console.log(err)
        })
    },
    getGameSum(gameData) {
      var totalNum = gameData.reduce((sum, game) => sum + game.num, 0)
      return totalNum
    },
    // 從全量遊戲篩出供應商（group 則為整組供應商）的遊戲，格式同 /game/ 回傳；全量尚未載入回傳 null
    getProviderGamesFromAllGame(provider) {
      if (!this.allGame.length) return null
      const providerIds = provider.providerIds || [provider.id]
      const list = this.allGame.filter(game => providerIds.includes(game.game_provider_id))
      return { list, page_info: { total_count: list.length }}
    },
    async fetchGamesFromAPI(queryObj) {
      const response = await getGames(queryObj)
      return response.data.data || []
    },
    async handleLaunchGame(game) {
      await launchGameWithProviderInfo(game)
    },
    checkTokenExpiration() {
      setInterval(() => {
        if (localStorage.getItem('token')) {
          const expiredTime = localStorage.getItem('expired_time')
          if (!expiredTime || new Date().getTime() > expiredTime) {
            this.updateToken()
          }
        }
      }, 60000)
    },
    updateToken() {
      if (localStorage.getItem('token')) {
        updateToken({ token: localStorage.getItem('token') }).then(response => {
          const tokenData = response.data.data.token
          const expiredTime = new Date().getTime() + (tokenData.expired_interval * 1000)
          localStorage.setItem('expired_time', expiredTime)
          localStorage.setItem('token', tokenData.token)
        }).catch(error => {
          console.error('Error updating token', error)
        })
      }
    },
    async getAllGameForSearch() {
      const response = await getGames({}, { noLoading: true, etagCache: true })
      this.allGame = response.data.data.list.filter(game => this.isActiveGame(game))

      this.$store.commit('SET_ALL_GAME', this.allGame)
    },
    isGameCategoryActive(item) {
      if (this.activeFilter === 'favorites' && item.isFavGame) return true
      // Check if the currently active filter matches the given category
      if (this.activeFilter === 'others' && this.currentGameCategory && this.currentGameCategory.id === item.id) {
        return true
      }
      return false
    },
    changeGameCategory(item) {
      if (!this.game.isGameReady) return

      // 我的最愛沒有分類路徑，離開目前的分類網址；其他分類由 currentGameCategory watcher 前往新路徑
      if (item.isFavGame && this.$route.params.seo_path) {
        this.$router.push('/')
      }

      const filterValue = item.isFavGame ? 'favorites' : 'others'

      if (filterValue === 'favorites') {
        this.$store.commit('SET_CURRENT_GAME_CATEGORY', null)
      } else {
        item.attribute = 'category'
        this.$store.commit('SET_CURRENT_GAME_CATEGORY', item)
      }

      this.$store.commit('SET_CURRENT_GAME_PROVIDER', null)
      this.$store.commit('SET_ACTIVE_FILTER', filterValue)
    },
    ...mapMutations(['SET_SHOW_RESEARCH', 'SET_SHOW_PROVIDER']),
    // 下拉選供應商：沿用原本供應商選擇；再點目前的供應商則返回上一層
    selectProvider(provider) {
      this.showProviderFilter = false
      if (this.isProviderSelected(provider)) {
        this.handleBack()
        return
      }
      this.changeGameProvider(provider)
    },
    // 下拉逐筆列出供應商；從首頁輪播選了整個 group 時（帶 providerIds）不算選中其中一筆
    isProviderSelected(provider) {
      const current = this.currentGameProvider
      return !!current && !current.providerIds && current.id === provider.id
    },
    getHomeSectionClass(item) {
      if (item.isProviders) return 'original-providers'
      if (item.isEvents) return ['new-events', { 'game-type': this.gameLobby }]
      return 'game-section'
    },
    changeGameProvider(item) {
      if (!this.game.isGameReady) return

      if (this.$route.params.seo_path) {
        this.$router.replace('/')
      }

      this.$store.commit('SET_CURRENT_GAME_CATEGORY', null)

      item.attribute = 'provider'
      this.$store.commit('SET_CURRENT_GAME_PROVIDER', item)
      this.$store.commit('SET_ACTIVE_FILTER', 'others')
    },
    closeProviderFilterOnOutside(event) {
      const filter = this.$refs.providerFilter
      if (this.showProviderFilter && filter && !filter.contains(event.target)) {
        this.showProviderFilter = false
      }
    },
    showSearchGame() {
      this.$store.commit('SET_SHOW_RESEARCH', true)
      this.$store.commit('SET_SHOW_PROVIDER', false)
    },
    openDemoGame(game) {
      this.$store.commit('SET_GAME_URL', game.demo_url)
    },
    clearQuery() {
      if (Object.keys(this.$route.query).length > 0) {
        this.$router.replace({ query: {}})
      }
    },
    isActiveGame(game) {
      return game.status === 1 && game.is_show === 1
    }
  }
}
</script>
